import YearPanel from './year-panel';

export default YearPanel;
